import Plyr from 'plyr';

document.querySelectorAll('[data-plyr-embed]').forEach((el) => {
  new Plyr(el);
});
